import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import ListEducationItem from '../../ListItem';
import './CourseAdded.scss';

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    marginBottom: 16,
    backgroundColor: 'white',
    marginTop: 8,
    padding: 0,
    '&$expanded': {
      '&:first-child': {
        marginTop: 24,
      },
    },
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    padding: 0,
    minHeight: 56,
    position: 'relative',
  },
  content: {
    margin: 0,
    width: '100%',

    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    color: '#6ecc47',
    alignSelf: 'flex-start',
    position: 'absolute',
    right: 16,
  },
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    padding: 0,
    color: '#484848',
    display: 'block',
  },
})(MuiExpansionPanelDetails);

const CoursesPanel = (props) => {
  const { elements, expanded } = props;

  return (
    <ExpansionPanel expanded={expanded}>
      {expanded ? null : (
        <ExpansionPanelSummary style={{ backgroundColor: 'white' }}>
          <div style={{ width: '100%' }}>
            {elements && !expanded
              ? elements.map((elem, index) => {
                  const { name, place, firstYear, lastYear } = elem;
                  if (index === 0 || index === 1) {
                    return (
                      <div className="courseAdded">
                        <div className="courseAdded_limit">
                          <div className="courseAdded_container">
                            <ListEducationItem>
                              <div>
                                {place && <p>{place}</p>}
                                {name && name && <p>{name}</p>}
                                {firstYear && lastYear && (
                                  <p>
                                    {firstYear} - {lastYear}
                                  </p>
                                )}
                              </div>
                            </ListEducationItem>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })
              : null}
          </div>
        </ExpansionPanelSummary>
      )}

      <ExpansionPanelDetails>
        <div style={{ width: '100%' }}>
          {elements &&
            elements.map((elem, index) => {
              const { name, place, firstYear, lastYear } = elem;
              return (
                <div className="courseAdded">
                  <div className="courseAdded_limit">
                    <div className="courseAdded_container">
                      <ListEducationItem>
                        <div>
                          {place && <p>{place}</p>}
                          {name && name && <p>{name}</p>}
                          {firstYear && lastYear && (
                            <p>
                              {firstYear} - {lastYear}
                            </p>
                          )}
                        </div>
                      </ListEducationItem>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default CoursesPanel;
